import { CHANNELS_FILTER_FIELDS } from './filter_fields/channels_filter_fields';
import { EPG_FILTER_FIELDS } from './filter_fields/epg_filter_fields';
import { VOD_FILTER_FIELDS } from './filter_fields/vod_filter_fields';
import { PAYMENTS_FILTER_FIELDS } from './filter_fields/payments_filter_fields';
import { SEASONS_FILTER_FIELDS } from './filter_fields/seasons_filter_fields';
import { EPISODES_FILTER_FIELDS } from './filter_fields/episodes_filter_fields';
import { PACKETS_FILTER_FIELDS } from './filter_fields/packets_filter_fields';
import { LIMITS_FILTER_FIELDS } from './filter_fields/limits_filter_fields';
import { SUBSCRIBERS_FILTER_FIELDS } from './filter_fields/subscribers_filter_fields';
import { CATEGORIES_FILTER_FIELDS } from './filter_fields/categories_filter_fields';
import { DOCUMENTS_FILTER_FIELDS } from './filter_fields/documents_filter_fields';
import { AGREEMENTS_FILTER_FIELDS } from './filter_fields/agreements_filter_fields';
import { SECTIONS_FILTER_FIELDS } from './filter_fields/sections_filter_fields';
import { BANNERS_FILTER_FIELDS } from './filter_fields/banners_filter_fields';
import { OPERATORS_FILTER_FIELDS } from './filter_fields/operators_filter_fields';
import { GEOLOCKS_FILTER_FIELDS } from './filter_fields/geolocks_filter_fields';
import { INGESTER_ENCODING_FILTER_FIELDS } from './filter_fields/encoding_filter_fields';
import { INGESTER_ASSETS_FILTER_FIELDS } from './filter_fields/assets_filter_fields';
import { PROVISIONING_FILTER_FIELDS } from './filter_fields/provisioning_filter_fields';
import { PROVISIONING_PRODUCTS_FILTER_FIELDS } from './filter_fields/provisioning_products_filter_fields';
import { MAIN_FILTER_FIELDS } from './filter_fields/main_filter_fields';
import { SOFTWARE_FILTER_FIELDS } from './filter_fields/software_filter_fields';
import { PROMOTIONS_FILTER_FIELDS } from './filter_fields/promotions_filter_fields';
import { VIDEO_ASSETS_PARAMS_FILTER_FIELDS } from './filter_fields/video_assets_params_filter_fields';
import { ASSIGNED_PACKETS_FILTER_FIELDS } from './filter_fields/assigned_packets_filter_fields';
import { EVENTS_LIVE_FILTER_FIELDS } from './filter_fields/events_live_filter_fields';
import { GEOBLOCK_GROUPS_FILTER_FIELDS } from './filter_fields/geoblock_groups_filter_fields';

export const FILTER_FIELDS = {
	channels: CHANNELS_FILTER_FIELDS,
	epg: EPG_FILTER_FIELDS,
	vod: VOD_FILTER_FIELDS,
	seasons: SEASONS_FILTER_FIELDS,
	episodes: EPISODES_FILTER_FIELDS,
	payments: PAYMENTS_FILTER_FIELDS,
	packets: PACKETS_FILTER_FIELDS,
	limits: LIMITS_FILTER_FIELDS,
	subscribers: SUBSCRIBERS_FILTER_FIELDS,
	categories: CATEGORIES_FILTER_FIELDS,
	documents: DOCUMENTS_FILTER_FIELDS,
	agreements: AGREEMENTS_FILTER_FIELDS,
	sections: SECTIONS_FILTER_FIELDS,
	banners: BANNERS_FILTER_FIELDS,
	operators: OPERATORS_FILTER_FIELDS,
	geolocks: GEOLOCKS_FILTER_FIELDS,
	encoding: INGESTER_ENCODING_FILTER_FIELDS,
	assets: INGESTER_ASSETS_FILTER_FIELDS,
	provisioning: PROVISIONING_FILTER_FIELDS,
	provisioning_products: PROVISIONING_PRODUCTS_FILTER_FIELDS,
	main: MAIN_FILTER_FIELDS,
	software: SOFTWARE_FILTER_FIELDS,
	promotions: PROMOTIONS_FILTER_FIELDS,
	'video-assets-params': VIDEO_ASSETS_PARAMS_FILTER_FIELDS,
	assigned_packets: ASSIGNED_PACKETS_FILTER_FIELDS,
	events_live: EVENTS_LIVE_FILTER_FIELDS,
	geoblock_groups: GEOBLOCK_GROUPS_FILTER_FIELDS
};
